<template>
    <div class="project-create">

        <h1>Criar Projecto</h1>

        <form @submit.prevent="createProject">

            <h4 for="workerSelect">Seleccione Serviço</h4>

            <div class="services">
                <label v-for="service in services" :key="service.id" class="service"
                    :class="{ selected: selectedServiceId == service.id }">
                    <input type="radio" :value="service.id" v-model="selectedServiceId" v-if="services"
                        name="service" />
                    {{ service.name }}
                </label>
            </div>

            <div v-if="selectedService">
                <p v-html="selectedService.description"></p>
            </div>

            <InputContent name="Nome" :label="$t('name')" placeholder="" v-model="name" v-if="selectedService" />

            <template v-if="selectedService">
                <div>
                    <label>
                        <div class="label">Descrição</div>
                        <textarea v-if="selectedService" v-model="description" placeholder="Escreva uma descrição...">
                        </textarea>
                    </label>
                </div>

                <br>
                <FileInput label="Ficheiros" :multiple="true" @change="addFiles" />
                <br>
                <div class="buttons">
                    <button class="button" type="submit">Criar</button>
                    <router-link :to="{ name: '' }">
                        <button class="button" type="button">Cancelar</button>
                    </router-link>
                </div>
            </template>

        </form>
    </div>
</template>

<script>
import FileInput from '@/components/inputs/File';
import InputContent from '@/components/inputs/Content.vue'

export default {
    name:'ProjectsCreate',
    props: {
        service: { default: null },
        project: { required: true },
    },
    components: {
        FileInput,
        InputContent,
    },
    data() {
        return {
            name: "",
            projects: [],
            selectedServiceId: "",
            description: '',
            files: [],
        }
    },
    methods: {
        addFiles(e) {
            this.files = e.target.files
        },
        createProject() {
            try {
                this.$store.dispatch('projects/create', {
                    name: this.name,
                    serviceId: this.selectedServiceId,
                    description: this.description,
                    files: this.files,
                })
            } catch (error) {
                console.log(error)
            }
        },
    },

    computed: {
        createdProject() {
            return this.$store.state.projects.created
        },
        currentUser() {
            return this.$store.state.users.currentUser
        },
        selectedService() {
            return this.selectedServiceId ? this.$store.getters['services/id'](this.selectedServiceId) : null;
        },
        services() {
            return this.$store.state.services.all;
        },
    },

    watch: {
        createdProject() {
            this.$router.push({ name: 'ProjectMessages', params: { id: this.createdProject } });
        },
    },

    async mounted() {
        await this.$store.dispatch('services/getAll');
        if (this.service) {
            this.selectedServiceId = this.service
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.project-create {
    display: flex;
    flex-direction: column;

    h1 {
        position: relative;
        margin: 0;
        padding: 0 2rem;
        text-align: left;
    }

    form {
        background-color: var(--sidebar-bg-color);
        padding: 2rem;
        margin: 2rem;
        border: 1px solid none;
        border-radius: 10px;
        box-shadow: 0 3px 6px rgba(var(--black), .16), 0 3px 6px rgba(var(--black), .23);

        label {
            input[type=file] {
                display: none;

                &+.label {
                    padding: 1rem;
                    border: 2px dashed;
                    border-radius: 10px;
                    width: fit-content;
                }
            }

            input,
            textarea {
                outline: none;
                padding: .5rem;
                background-color: var(--bg-color-2);
                border: 2px solid var(--bg-color-2);
                color: var(--text-color);
                border-radius: 5px;

                &:focus {
                    border: 2px solid var(--highlight-color);
                }
            }

            textarea {
                height: 300px;
                outline: none;
                width: 100%;
            }

            img {
                max-width: 50px;
                max-height: 50px;
            }

            .label {
            }
        }

        h4 {
            color: var(--text-color);
            font-weight: bold;
        }

        .services {
            display: flex;
            gap: 1rem;
            margin: 0.5rem 0.5rem 0 0;

            .service {
                display: inline-block;
                padding: 0.5em;
                text-align: center;
                cursor: pointer;
                border: 1px solid var(--border-color);
                border-radius: 0.25em;
                transition: 0.1s;
                user-select: none;
                appearance: none;
                flex-grow: 1;
                background-color: var(--bg-color-2);

                &:hover {
                    background-color: var(--bg-color-3);
                    border-color: var(--border-color);
                }

                &:active {
                    transform: translateY(2px);
                }

                &.selected {
                    background: var(--highlight-color);
                    color: var(--white);
                    border-color: var(--white);
                }
            }
        }

        .attachment {
            display: flex;
            transition: .2s ease-out;
            transition-property: width, padding;
            display: flex;
            width: 2.5rem;
            padding: .5rem;
            cursor: pointer;

            input {
                display: none;
            }
        }

        .buttons {
            display: flex;
            justify-content: space-between;
            gap: 1rem;
            width: 100%;

            .button {
                flex: 1;
                padding: 1rem;
                font-size: 18px;
                cursor: pointer;
                text-align: center;
                border: none;
                border-radius: 5px;
                background-color: var(--text-color);
                color: var(--white);
                transition: background-color 0.3s ease;

                &:hover {
                    background-color: var(--highlight-color, 10%);
                }

                &[type="button"] {
                    background-color: var(--text-second-color);

                    &:hover {
                        background-color: var(--text-darken-color);
                    }
                }
            }
        }
    }
}

input {
    overflow: hidden;
    width: 0;
    height: 0;
    margin-right: -5px;
}
</style>
